export const kindOfIconButton = {
  Message: (
    <svg
      fill="none"
      height="10"
      viewBox="0 0 14 10"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89464 0.734784 10 1 10H13C13.2652 10 13.5196 9.89464 13.7071 9.70711C13.8946 9.51957 14 9.26522 14 9V1C14 0.734784 13.8946 0.48043 13.7071 0.292893C13.5196 0.105357 13.2652 0 13 0ZM11.9 1L7 4.39L2.1 1H11.9ZM1 9V1.455L6.715 5.41C6.7987 5.46806 6.89813 5.49918 7 5.49918C7.10187 5.49918 7.2013 5.46806 7.285 5.41L13 1.455V9H1Z"
        fill="#F5F5F5"
      />
    </svg>
  ),
  Menu: (
    <svg
      fill="none"
      height="12"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 2.5H12" stroke="#1E1F22" />
      <path d="M0 9.5L12 9.5" stroke="#1E1F22" />
      <path
        d="M2 2.5C2 1.39543 2.89543 0.5 4 0.5C5.10457 0.5 6 1.39543 6 2.5C6 3.60457 5.10457 4.5 4 4.5C2.89543 4.5 2 3.60457 2 2.5Z"
        fill="#1E1F22"
      />
      <path
        d="M6 9.5C6 8.39543 6.89543 7.5 8 7.5C9.10457 7.5 10 8.39543 10 9.5C10 10.6046 9.10457 11.5 8 11.5C6.89543 11.5 6 10.6046 6 9.5Z"
        fill="#1E1F22"
      />
    </svg>
  ),
  Close: (
    <svg
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="10px"
    >
      <path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z" />
    </svg>
  ),
  BoldClose: (
    <svg
      fill="#404040"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width="18"
      height="18"
    >
      <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" />
    </svg>
  ),
  Submit: (
    <svg
      fill="white"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5837 2.91653L6.6587 7.84575L7.94349 11.6177L11.5837 2.91653ZM6.14478 7.3314L11.0698 2.40218L2.37606 6.08838L6.14478 7.3314ZM12.4831 1.03057C12.7829 0.901983 13.1255 1.20202 12.9542 1.50206L8.24327 12.775C8.11479 13.075 7.6437 13.075 7.55805 12.775L5.93065 8.06007L1.26258 6.43128C0.919969 6.34556 0.919969 5.91693 1.21975 5.78834L12.4831 1.03057Z"
        strokeWidth="0.2"
      />
    </svg>
  ),
  Share: (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 15 15"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5125 9.01573C10.1383 9.01761 9.76922 9.1035 9.43258 9.26705C9.09595 9.43061 8.80033 9.66767 8.56754 9.96073L4.91254 7.67573C5.04575 7.24581 5.04575 6.78565 4.91254 6.35573L8.56754 4.07073C8.93852 4.53009 9.4601 4.84332 10.0399 4.95493C10.6197 5.06655 11.2203 4.96934 11.7353 4.68054C12.2503 4.39174 12.6465 3.92997 12.8536 3.37705C13.0607 2.82413 13.0655 2.21574 12.867 1.65964C12.6685 1.10355 12.2796 0.635657 11.7692 0.338842C11.2588 0.0420275 10.6598 -0.0645479 10.0783 0.0379951C9.49684 0.140538 8.97043 0.445581 8.59232 0.899087C8.21422 1.35259 8.00883 1.92529 8.01254 2.51573C8.0149 2.73932 8.04856 2.96147 8.11254 3.17573L4.45754 5.46073C4.13487 5.05452 3.69381 4.75875 3.19552 4.61442C2.69723 4.4701 2.16637 4.48436 1.67655 4.65523C1.18672 4.82611 0.762188 5.14513 0.461787 5.56808C0.161386 5.99103 0 6.49695 0 7.01573C0 7.5345 0.161386 8.04043 0.461787 8.46338C0.762188 8.88632 1.18672 9.20535 1.67655 9.37622C2.16637 9.54709 2.69723 9.56136 3.19552 9.41703C3.69381 9.2727 4.13487 8.97694 4.45754 8.57073L8.11254 10.8557C8.04856 11.07 8.0149 11.2921 8.01254 11.5157C8.01254 12.0102 8.15916 12.4935 8.43387 12.9047C8.70857 13.3158 9.09902 13.6362 9.55583 13.8254C10.0126 14.0146 10.5153 14.0642 11.0003 13.9677C11.4852 13.8712 11.9307 13.6331 12.2803 13.2835C12.6299 12.9339 12.868 12.4884 12.9645 12.0035C13.061 11.5185 13.0115 11.0158 12.8222 10.559C12.633 10.1022 12.3126 9.71176 11.9015 9.43705C11.4903 9.16235 11.007 9.01573 10.5125 9.01573ZM10.5125 1.01573C10.8092 1.01573 11.0992 1.1037 11.3459 1.26852C11.5926 1.43334 11.7848 1.66761 11.8984 1.9417C12.0119 2.21579 12.0416 2.51739 11.9837 2.80836C11.9258 3.09933 11.783 3.36661 11.5732 3.57639C11.3634 3.78617 11.0962 3.92903 10.8052 3.98691C10.5142 4.04478 10.2126 4.01508 9.93852 3.90155C9.66443 3.78802 9.43016 3.59576 9.26534 3.34908C9.10052 3.10241 9.01254 2.8124 9.01254 2.51573C9.01254 2.1179 9.17058 1.73637 9.45188 1.45507C9.73319 1.17376 10.1147 1.01573 10.5125 1.01573ZM2.51254 8.51573C2.21587 8.51573 1.92586 8.42775 1.67919 8.26293C1.43251 8.09811 1.24026 7.86384 1.12672 7.58975C1.01319 7.31566 0.983487 7.01406 1.04137 6.72309C1.09924 6.43212 1.2421 6.16485 1.45188 5.95507C1.66166 5.74529 1.92894 5.60243 2.21991 5.54455C2.51088 5.48667 2.81248 5.51638 3.08657 5.62991C3.36066 5.74344 3.59493 5.9357 3.75975 6.18237C3.92457 6.42905 4.01254 6.71906 4.01254 7.01573C4.01254 7.41355 3.85451 7.79508 3.5732 8.07639C3.2919 8.35769 2.91037 8.51573 2.51254 8.51573ZM10.5125 13.0157C10.2159 13.0157 9.92586 12.9278 9.67919 12.7629C9.43251 12.5981 9.24025 12.3638 9.12672 12.0898C9.01319 11.8157 8.98349 11.5141 9.04136 11.2231C9.09924 10.9321 9.2421 10.6648 9.45188 10.4551C9.66166 10.2453 9.92894 10.1024 10.2199 10.0445C10.5109 9.98667 10.8125 10.0164 11.0866 10.1299C11.3607 10.2434 11.5949 10.4357 11.7597 10.6824C11.9246 10.929 12.0125 11.2191 12.0125 11.5157C12.0125 11.9136 11.8545 12.2951 11.5732 12.5764C11.2919 12.8577 10.9104 13.0157 10.5125 13.0157Z"
        fill="#F5F5F5"
      />
    </svg>
  ),
  pdf: (
    <svg
      xmlSpace="preserve"
      version="1.1"
      viewBox="0 0 48 48"
      x="0px"
      xmlns="http://www.w3.org/2000/svg" y="0px"
      width="43"
      height="43"
    >
      <path
        d="M28,28v2h-8v-2h-1v2c0,0.3,0.1,0.5,0.3,0.7S19.7,31,20,31h8c0.3,0,0.5-0.1,0.7-0.3S29,30.3,29,30v-2H28z"
        fill="#FFFFFF"/>
      <path
        d="M26.5,26.5l-0.7-0.7l-1.3,1.3V23h-1v4.1l-1.3-1.3l-0.7,0.7L24,29L26.5,26.5z"
        fill="#FFFFFF"/>
      <path
        d="M18,21v-4.5h2.2c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3-0.1,0.5-0.2,0.8
      c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.2-0.8,0.2h-1.3V21H18z M18.8,18.7h1.3c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5
      c0-0.2,0-0.3-0.1-0.4s-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.4-0.1h-1.3V18.7z"
        fill="#FFFFFF"/>
      <path
        d="M22.3,21v-4.5h1.8c0.5,0,0.8,0.1,1.2,0.2c0.3,0.2,0.6,0.4,0.7,0.7c0.2,0.3,0.3,0.7,0.3,1.3
      c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.3-0.4,0.6-0.7,0.7C25,20.9,24.6,21,24.1,21H22.3z M23.2,20.3h0.9c0.2,0,0.4,0,0.6-0.1
      c0.2-0.1,0.3-0.1,0.4-0.3c0.1-0.1,0.2-0.3,0.2-0.4c0.1-0.2,0.1-0.4,0.1-0.6v-0.1c0-0.2,0-0.5-0.1-0.6c-0.1-0.2-0.1-0.3-0.2-0.4
      c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.6-0.1h-0.9V20.3z"
        fill="#FFFFFF"/>
      <path
        d="M27.1,21v-4.5h3.2v0.7h-2.4v1.2H30v0.7h-2.1V21H27.1z"
        fill="#FFFFFF"/>
    </svg>
  ),
  jpg: (
    <svg
      xmlSpace="preserve"
      version="1.1"
      viewBox="0 0 48 48"
      x="0px"
      xmlns="http://www.w3.org/2000/svg" y="0px"
      width="43"
      height="43"
    >
      <path
        d="M28,28v2h-8v-2h-1v2c0,0.3,0.1,0.5,0.3,0.7S19.7,31,20,31h8c0.3,0,0.5-0.1,0.7-0.3S29,30.3,29,30v-2H28z"
        fill="#FFFFFF"/>
      <path
        d="M26.5,26.5l-0.7-0.7l-1.3,1.3V23h-1v4.1l-1.3-1.3l-0.7,0.7L24,29L26.5,26.5z"
        fill="#FFFFFF"/>
      <path
        d="M19.1,21.1c-0.3,0-0.6,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.2-0.4-0.2-0.7v-0.2h0.8v0.2
      c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4-0.1,0.5-0.2c0.1-0.2,0.2-0.4,0.2-0.7v-2.9h0.9v2.9c0,0.4-0.1,0.7-0.2,0.9
      c-0.1,0.2-0.3,0.4-0.5,0.5C19.7,21,19.5,21.1,19.1,21.1z"
        fill="#FFFFFF"
      />
      <path
        d="M21.6,21v-4.5h2.2c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8
      c0,0.3-0.1,0.5-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.2-0.8,0.2h-1.3V21H21.6z M22.5,18.7h1.3c0.2,0,0.4-0.1,0.5-0.2
      c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2,0-0.3-0.1-0.4s-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.4-0.1h-1.3V18.7z"
        fill="#FFFFFF"
      />
      <path
        d="M28,21.1c-0.7,0-1.2-0.2-1.6-0.6c-0.4-0.4-0.6-1-0.6-1.8c0-0.5,0.1-1,0.3-1.3c0.2-0.3,0.4-0.6,0.8-0.8
      c0.3-0.2,0.8-0.3,1.2-0.3c0.3,0,0.6,0,0.8,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.3,0.3,0.5,0.5c0.1,0.2,0.2,0.4,0.2,0.7h-0.9
      c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.1-0.2-0.3-0.3c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.6,0.1
      c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.3-0.3,0.5c-0.1,0.2-0.1,0.4-0.1,0.7v0.1c0,0.4,0,0.6,0.1,0.9c0.1,0.2,0.2,0.4,0.4,0.5
      c0.2,0.1,0.5,0.2,0.8,0.2c0.3,0,0.5,0,0.7-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.2,0.2-0.3,0.2-0.6v0h-1.4v-0.7h2.3V21h-0.6l-0.1-0.5
      c-0.1,0.1-0.3,0.2-0.4,0.3C29,20.9,28.8,21,28.6,21C28.4,21.1,28.2,21.1,28,21.1z"
        fill="#FFFFFF"
      />
    </svg>
  ),
  png: (
    <svg xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      width="43"
      height="43"
    >
      {/* <rect width="43" height="43" rx="24" fill="#231F20"/> */}
      <path d="M28 28V30H20V28H19V30C19 30.2652 19.1054 30.5196 19.2929 30.7071C19.4804 30.8946 19.7348 31 20 31H28C28.2652 31 28.5196 30.8946 28.7071 30.7071C28.8946 30.5196 29 30.2652 29 30V28H28Z" fill="white"/>
      <path d="M26.5 26.5L25.793 25.793L24.5 27.086V23H23.5V27.086L22.207 25.793L21.5 26.5L24 29L26.5 26.5Z" fill="white"/>
      <path d="M17.4941 16.3605H19.5416C19.871 16.3605 20.1396 16.4082 20.3476 16.5035C20.5556 16.5988 20.716 16.718 20.8286 16.861C20.9413 17.004 21.0171 17.16 21.0561 17.329C21.0995 17.498 21.1211 17.654 21.1211 17.797C21.1211 17.94 21.0995 18.096 21.0561 18.265C21.0171 18.4297 20.9413 18.5835 20.8286 18.7265C20.716 18.8695 20.5556 18.9887 20.3476 19.084C20.1396 19.175 19.871 19.2205 19.5416 19.2205H18.3066V21.0015H17.4941V16.3605ZM18.3066 18.5575H19.4961C19.5871 18.5575 19.6803 18.5445 19.7756 18.5185C19.871 18.4925 19.9576 18.4513 20.0356 18.395C20.118 18.3343 20.183 18.2563 20.2306 18.161C20.2826 18.0613 20.3086 17.9378 20.3086 17.7905C20.3086 17.6388 20.287 17.5132 20.2436 17.4135C20.2003 17.3138 20.1418 17.2358 20.0681 17.1795C19.9945 17.1188 19.91 17.0777 19.8146 17.056C19.7193 17.0343 19.6175 17.0235 19.5091 17.0235H18.3066V18.5575Z" fill="white"/>
      <path d="M21.7971 16.3605H22.6551L24.7741 19.7795H24.7871V16.3605H25.5606V21.0015H24.7026L22.5901 17.589H22.5706V21.0015H21.7971V16.3605Z" fill="white"/>
      <path d="M30.57 21.0015H30.05L29.9265 20.4555C29.7098 20.7025 29.4932 20.8737 29.2765 20.969C29.0598 21.0643 28.8107 21.112 28.529 21.112C28.1823 21.112 27.8703 21.0492 27.593 20.9235C27.32 20.7935 27.0882 20.618 26.8975 20.397C26.7068 20.176 26.5595 19.9182 26.4555 19.6235C26.3558 19.3288 26.306 19.0147 26.306 18.681C26.306 18.3517 26.3558 18.0397 26.4555 17.745C26.5595 17.4503 26.7068 17.1925 26.8975 16.9715C27.0882 16.7505 27.32 16.575 27.593 16.445C27.8703 16.315 28.1823 16.25 28.529 16.25C28.7803 16.25 29.0187 16.2847 29.244 16.354C29.4737 16.419 29.6773 16.5187 29.855 16.653C30.0327 16.783 30.18 16.9477 30.297 17.147C30.414 17.3463 30.4877 17.576 30.518 17.836H29.725C29.7033 17.6843 29.6557 17.5522 29.582 17.4395C29.5127 17.3225 29.4238 17.225 29.3155 17.147C29.2072 17.069 29.0858 17.0105 28.9515 16.9715C28.8172 16.9325 28.6763 16.913 28.529 16.913C28.282 16.913 28.0675 16.9628 27.8855 17.0625C27.7078 17.1622 27.5627 17.2965 27.45 17.4655C27.3373 17.6302 27.2528 17.8187 27.1965 18.031C27.1445 18.2433 27.1185 18.46 27.1185 18.681C27.1185 18.902 27.1445 19.1187 27.1965 19.331C27.2528 19.5433 27.3373 19.734 27.45 19.903C27.5627 20.0677 27.7078 20.1998 27.8855 20.2995C28.0675 20.3992 28.282 20.449 28.529 20.449C28.737 20.4533 28.9212 20.4273 29.0815 20.371C29.2418 20.3103 29.3762 20.2258 29.4845 20.1175C29.5972 20.0048 29.6817 19.8683 29.738 19.708C29.7943 19.5477 29.8247 19.37 29.829 19.175H28.594V18.5575H30.57V21.0015Z" fill="white"/>
    </svg>
  ),
  ArrowRight: (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 25 17"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8.5H24M24 8.5L16.5538 1M24 8.5L16.5538 16"
        stroke="#1E1F22"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  ArrowLeft: (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 25 17"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 8.5H1M1 8.5L8.44615 1M1 8.5L8.44615 16"
        stroke="#1E1F22"
        strokeLinejoin="bevel"
      />
    </svg>
  ),
  Tick: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path
        fill="#1251B5"
        d="M9 16.17L5.53 12.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L9 16.17z"
      />
    </svg>
  ),
  Info: (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M8.82827 8.556C8.90262 8.556 10.4681 8.33249 11.9778 7.53125V14.408C11.9778 14.408 11.9778 14.9484 12.3505 14.9673L13.0026 15.0606V15.5639C13.0026 15.5639 8.8001 15.5921 8.82827 15.5639C8.85644 15.5358 8.82827 14.9862 8.82827 14.9862C8.82827 14.9862 9.87195 15.0236 9.87195 14.6135V9.65557C9.87195 9.65557 9.90936 9.04044 9.4808 9.02197C9.05224 9.00349 8.82827 9.0035 8.82827 9.0035V8.556Z" fill="#010202"/>
      <path d="M10.8592 6.2321C11.5899 6.2321 12.1823 5.63974 12.1823 4.90902C12.1823 4.1783 11.5899 3.58594 10.8592 3.58594C10.1285 3.58594 9.53613 4.1783 9.53613 4.90902C9.53613 5.63974 10.1285 6.2321 10.8592 6.2321Z" fill="#010202"/>
      <path d="M10.8574 20C8.18632 20 5.67501 18.96 3.78621 17.0712C1.89741 15.1824 0.857422 12.6711 0.857422 10C0.857422 7.3289 1.89741 4.81759 3.78621 2.92879C5.67501 1.03999 8.18632 0 10.8574 0C13.5285 0 16.0398 1.03999 17.9286 2.92879C19.8174 4.81759 20.8574 7.3289 20.8574 10C20.8574 12.6711 19.8174 15.1824 17.9286 17.0712C16.0398 18.96 13.5285 20 10.8574 20ZM10.8574 0.923617C5.8528 0.923617 1.78104 4.99538 1.78104 10C1.78104 15.0046 5.8528 19.0764 10.8574 19.0764C15.862 19.0764 19.9338 15.0046 19.9338 10C19.9338 4.99538 15.8625 0.923617 10.8574 0.923617Z" fill="#010202"/>
    </svg>  ),
  Facebook: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="24px"
      height="24px"
      viewBox="0 0 256 256"
    >
      <g transform="translate(128 128) scale(0.72 0.72)">
        <g transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)">
          <path
            d="M 85.033 -0.001 H 4.967 C 2.224 -0.001 0 2.223 0 4.967 v 80.066 C 0 87.775 2.223 90 4.967 90 h 40.922 V 55.147 H 34.16 V 41.564 h 11.729 V 31.547 c 0 -11.625 7.1 -17.954 17.47 -17.954 c 4.967 0 9.237 0.37 10.481 0.535 v 12.149 l -7.193 0.003 c -5.639 0 -6.731 2.68 -6.731 6.612 v 8.672 h 13.45 l -1.752 13.583 H 59.916 V 90 h 25.117 C 87.776 90 90 87.776 90 85.032 V 4.967 C 90 2.223 87.776 -0.001 85.033 -0.001 z"
            transform=" matrix(1 0 0 1 0 0) "
            strokeLinecap="round"
            fill="rgb(60,90,153)"
          />
        </g>
      </g>
    </svg>
  ),
  FacebookSecondIcon: (<svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path d="M11.335 0H0.665C0.489035 0.00130834 0.320649 0.0717907 0.19622 0.19622C0.0717907 0.320649 0.00130834 0.489035 0 0.665V11.335C0.00130834 11.511 0.0717907 11.6794 0.19622 11.8038C0.320649 11.9282 0.489035 11.9987 0.665 12H6.41V7.36H4.85V5.545H6.41V4.21C6.41 2.66 7.355 1.815 8.745 1.815C9.21 1.815 9.675 1.815 10.14 1.885V3.5H9.185C8.43 3.5 8.285 3.86 8.285 4.385V5.54H10.085L9.85 7.355H8.285V12H11.335C11.511 11.9987 11.6794 11.9282 11.8038 11.8038C11.9282 11.6794 11.9987 11.511 12 11.335V0.665C11.9987 0.489035 11.9282 0.320649 11.8038 0.19622C11.6794 0.0717907 11.511 0.00130834 11.335 0Z" fill="#1251B5"></path></svg>
  ),
  MessageBlack: (
    <svg
      fill="#000"
      height="10"
      viewBox="0 0 14 10"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89464 0.734784 10 1 10H13C13.2652 10 13.5196 9.89464 13.7071 9.70711C13.8946 9.51957 14 9.26522 14 9V1C14 0.734784 13.8946 0.48043 13.7071 0.292893C13.5196 0.105357 13.2652 0 13 0ZM11.9 1L7 4.39L2.1 1H11.9ZM1 9V1.455L6.715 5.41C6.7987 5.46806 6.89813 5.49918 7 5.49918C7.10187 5.49918 7.2013 5.46806 7.285 5.41L13 1.455V9H1Z"
        fill="#000"
      />
    </svg>
  ),
  Star: (
    <svg
      id="Star-001"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 122.88 117.19"
      width="20"
      height="20"
      fill="none"
    >
      <path
        d="M64.39,2,80.11,38.76,120,42.33a3.2,3.2,0,0,1,1.83,5.59h0L91.64,74.25l8.92,39a3.2,3.2,0,0,1-4.87,3.4L61.44,96.19,27.09,116.73a3.2,3.2,0,0,1-4.76-3.46h0l8.92-39L1.09,47.92A3.2,3.2,0,0,1,3,42.32l39.74-3.56L58.49,2a3.2,3.2,0,0,1,5.9,0Z"
        stroke="#1E1F22"
        strokeWidth="6"
      />
    </svg>
  ),
  CloseGrey: (
    <svg
      fill="#4D4E53"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="15px"
      height="15px"
    >
      <path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z" />
    </svg>
  ),
  AR: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.7686 2.9846C13.8472 3.01883 13.9143 3.07564 13.9564 3.15103C13.9584 3.15462 13.9604 3.15823 13.9622 3.16185C13.9663 3.1698 13.9701 3.17788 13.9736 3.18608C13.9926 3.23121 14.001 3.27756 13.9999 3.3232V5.89474C13.9999 6.09821 13.8156 6.26316 13.5882 6.26316C13.3607 6.26316 13.1764 6.09821 13.1764 5.89474V3.91191L11.3017 4.75058C11.0983 4.84157 10.851 4.76781 10.7493 4.58582C10.6476 4.40382 10.7301 4.18252 10.9335 4.09153L12.6674 3.31579L10.9335 2.54005C10.7301 2.44906 10.6476 2.22776 10.7493 2.04576C10.851 1.86377 11.0983 1.79 11.3017 1.881L13.7686 2.9846ZM13.9999 10.6768C14.0012 10.7309 13.9891 10.786 13.9622 10.8381C13.9421 10.8774 13.9143 10.9132 13.8801 10.944C13.8455 10.9748 13.8085 10.998 13.7686 11.0154L11.3017 12.119C11.0983 12.21 10.851 12.1362 10.7493 11.9542C10.6476 11.7722 10.7301 11.5509 10.9335 11.4599L12.6674 10.6842L10.9335 9.90847C10.7301 9.81748 10.6476 9.59618 10.7493 9.41418C10.851 9.23219 11.0983 9.15843 11.3017 9.24942L13.1764 10.0881V8.10526C13.1764 7.90179 13.3607 7.73684 13.5882 7.73684C13.8156 7.73684 13.9999 7.90179 13.9999 8.10526V10.6768ZM1.33257 10.6842L3.06655 11.4599C3.26995 11.5509 3.3524 11.7722 3.25069 11.9542C3.14899 12.1362 2.90166 12.21 2.69826 12.119L0.231425 11.0154C0.152799 10.9812 0.0856863 10.9244 0.0435608 10.849C0.0415523 10.8454 0.0396159 10.8418 0.0377506 10.8381C0.0336666 10.8302 0.0298945 10.8221 0.0264442 10.8139C0.00744735 10.7688 -0.000979397 10.7224 9.0198e-05 10.6768V8.10526C9.0198e-05 7.90179 0.184441 7.73684 0.41185 7.73684C0.639258 7.73684 0.823609 7.90179 0.823609 8.10526V10.0881L2.69826 9.24942C2.90166 9.15843 3.14899 9.23219 3.25069 9.41418C3.3524 9.59618 3.26995 9.81748 3.06655 9.90847L1.33257 10.6842ZM0.823609 3.91191V5.89474C0.823609 6.09821 0.639258 6.26316 0.41185 6.26316C0.184441 6.26316 9.0198e-05 6.09821 9.0198e-05 5.89474V3.3232C-0.00117735 3.26911 0.0108918 3.21403 0.0377506 3.16185C0.0579184 3.12263 0.0856902 3.08677 0.119852 3.05602C0.154523 3.0252 0.191489 3.00198 0.231425 2.9846L2.69826 1.881C2.90166 1.79 3.14899 1.86377 3.25069 2.04576C3.3524 2.22776 3.26995 2.44906 3.06655 2.54005L1.33257 3.31579L3.06655 4.09153C3.26995 4.18252 3.3524 4.40382 3.25069 4.58582C3.14899 4.76781 2.90166 4.84157 2.69826 4.75058L0.823609 3.91191ZM6.80845 0.0422099C6.86567 0.0152552 6.93084 0 7 0C7.06916 0 7.13434 0.0152552 7.19155 0.0422099L9.6547 1.14416C9.8581 1.23515 9.94055 1.45645 9.83885 1.63845C9.73715 1.82044 9.48981 1.89421 9.28641 1.80321L7.41176 0.964539V2.94737C7.41176 3.15084 7.22741 3.31579 7 3.31579C6.77259 3.31579 6.58824 3.15084 6.58824 2.94737V0.964539L4.71359 1.80321C4.51019 1.89421 4.26286 1.82044 4.16116 1.63845C4.05946 1.45645 4.1419 1.23515 4.3453 1.14416L6.80845 0.0422099ZM7.19155 13.9578C7.13434 13.9847 7.06916 14 7 14C6.93084 14 6.86567 13.9847 6.80845 13.9578L4.3453 12.8558C4.1419 12.7648 4.05946 12.5435 4.16116 12.3616C4.26286 12.1796 4.51019 12.1058 4.71359 12.1968L6.58824 13.0355V11.0526C6.58824 10.8492 6.77259 10.6842 7 10.6842C7.22741 10.6842 7.41176 10.8492 7.41176 11.0526V13.0355L9.28641 12.1968C9.48981 12.1058 9.73715 12.1796 9.83885 12.3616C9.94055 12.5435 9.8581 12.7648 9.6547 12.8558L7.19155 13.9578ZM7.41176 6.49085V8.47368C7.41176 8.67716 7.22741 8.8421 7 8.8421C6.77259 8.8421 6.58824 8.67716 6.58824 8.47368V6.49085L4.3453 5.48742C4.1419 5.39642 4.05946 5.17512 4.16116 4.99313C4.26286 4.81114 4.51019 4.73737 4.71359 4.82837L7 5.85125L9.28641 4.82837C9.48981 4.73737 9.73715 4.81114 9.83885 4.99313C9.94055 5.17512 9.8581 5.39642 9.6547 5.48742L7.41176 6.49085Z" fill="#F5F5F5"/>
    </svg>

  ),
  AppStore: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.256 0H18.744C21.6469 0 24 2.35312 24 5.256V18.744C24 21.6469 21.6469 24 18.744 24H5.256C2.35312 24 0 21.6469 0 18.744V5.256C0 2.35312 2.35312 0 5.256 0Z" fill="url(#paint0_linear_2367_8074)"/>
      <path d="M7.69133 17.4172L7.69358 17.418L6.87298 18.8392C6.57345 19.3581 5.91008 19.5358 5.39127 19.2363C4.87255 18.9367 4.6947 18.2734 4.99423 17.7546L5.59873 16.7076L5.65677 16.6071C5.76036 16.4582 6.01602 16.2011 6.52742 16.2495C6.52742 16.2495 7.73089 16.3801 7.81798 17.0056C7.81798 17.0056 7.8298 17.2114 7.69133 17.4172ZM19.3297 13.7872H16.7709C16.5966 13.7755 16.5206 13.7133 16.4906 13.6771L16.4887 13.6738L13.7496 8.9295L13.7461 8.93184L13.5818 8.69634C13.3126 8.28459 12.8851 9.33759 12.8851 9.33759C12.3746 10.511 12.9575 11.8449 13.1607 12.2482L16.9653 18.8378C17.2647 19.3566 17.9281 19.5344 18.447 19.2348C18.9657 18.9352 19.1435 18.2719 18.8439 17.7531L17.8926 16.1053C17.8742 16.0654 17.8421 15.957 18.0372 15.9565H19.3297C19.9288 15.9565 20.4144 15.4709 20.4144 14.8718C20.4144 14.2728 19.9288 13.7872 19.3297 13.7872V13.7872ZM14.3597 15.2617C14.3597 15.2617 14.4963 15.9565 13.9678 15.9565H4.50852C3.90945 15.9565 3.42383 15.4709 3.42383 14.8718C3.42383 14.2728 3.90945 13.7872 4.50852 13.7872H6.94039C7.33302 13.7645 7.42602 13.5378 7.42602 13.5378L7.42827 13.5389L10.6026 8.04065L10.6017 8.04047C10.6595 7.93425 10.6114 7.83384 10.603 7.818L9.55461 6.00215C9.25508 5.48343 9.43283 4.81997 9.95164 4.52053C10.4705 4.221 11.1338 4.39865 11.4334 4.91747L11.9195 5.75962L12.4049 4.91897C12.7044 4.40025 13.3678 4.2224 13.8866 4.52203C14.4054 4.82156 14.5832 5.48484 14.2836 6.00365L9.86633 13.6546C9.84702 13.7012 9.84111 13.7743 9.98483 13.7872H12.6252L12.6258 13.8129C12.6258 13.8129 14.1518 13.8367 14.3597 15.2617Z" fill="white"/>
      <defs>
        <linearGradient id="paint0_linear_2367_8074" x1="12" y1="0" x2="12" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17C9FB"/>
          <stop offset="1" stopColor="#1A74E8"/>
        </linearGradient>
      </defs>
    </svg>

  ),
  GoogleStore: (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.2261 15.6684C19.0156 14.1072 21.1303 12.9177 21.3125 12.8252C21.8956 12.5091 22.4978 11.6727 21.3125 11.0229C20.9299 10.8185 18.8695 9.66602 16.2261 8.17969L12.5615 11.9518L16.2261 15.6683V15.6684Z" fill="#FFD900"/>
      <path d="M12.5614 11.9531L0.893066 23.9394C1.16695 23.9763 1.47615 23.9023 1.8407 23.6981C2.60606 23.2711 10.7196 18.7549 16.226 15.6706L12.5614 11.9531Z" fill="#F43249"/>
      <path d="M12.5615 11.9513L16.226 8.19774C16.226 8.19774 2.66147 0.652543 1.84077 0.207142C1.53156 0.0204849 1.18506 -0.0349604 0.875 0.0204849L12.5615 11.9513Z" fill="#00EE76"/>
      <path d="M12.5616 11.9503L0.875101 0.0195312C0.400812 0.131298 0 0.558393 0 1.43185V22.5243C0 23.3237 0.310148 23.8995 0.893234 23.9551L12.5616 11.9503Z" fill="#00D3FF"/>
    </svg>
  ),
  Reload: (
    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="18px" height="18px">
      <path d="M 15 3 C 12.031398 3 9.3028202 4.0834384 7.2070312 5.875 A 1.0001 1.0001 0 1 0 8.5058594 7.3945312 C 10.25407 5.9000929 12.516602 5 15 5 C 20.19656 5 24.450989 8.9379267 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.437925 7.8516588 21.277839 3 15 3 z M 4 10 L 0 16 L 3.0507812 16 C 3.562075 22.148341 8.7221607 27 15 27 C 17.968602 27 20.69718 25.916562 22.792969 24.125 A 1.0001 1.0001 0 1 0 21.494141 22.605469 C 19.74593 24.099907 17.483398 25 15 25 C 9.80344 25 5.5490109 21.062074 5.0488281 16 L 8 16 L 4 10 z" />
    </svg>
  ),
  Loading: (
    <svg width="43" height="43" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="75" cy="50" fill="#fff" r="6.39718">
        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" dur="1s" repeatCount="indefinite" begin="-0.875s"></animate>
      </circle>
      <circle cx="67.678" cy="67.678" fill="#fff" r="4.8">
        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
      </circle>
      <circle cx="50" cy="75" fill="#fff" r="4.8">
        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" dur="1s" repeatCount="indefinite" begin="-0.625s"></animate>
      </circle>
      <circle cx="32.322" cy="67.678" fill="#fff" r="4.8">
        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
      </circle>
      <circle cx="25" cy="50" fill="#fff" r="4.8">
        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" dur="1s" repeatCount="indefinite" begin="-0.375s"></animate>
      </circle>
      <circle cx="32.322" cy="32.322" fill="#fff" r="4.80282">
        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
      </circle>
      <circle cx="50" cy="25" fill="#fff" r="6.40282">
        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" dur="1s" repeatCount="indefinite" begin="-0.125s"></animate>
      </circle>
      <circle cx="67.678" cy="32.322" fill="#fff" r="7.99718">
        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" dur="1s" repeatCount="indefinite" begin="0s"></animate>
      </circle>
    </svg>
  ),
  RealImage360: (
    <svg  fill="none" height="15" viewBox="0 0 17 12" width="17" xmlns="http://www.w3.org/2000/svg">
      <rect  height="11" stroke="#1E1F22" width="16" x="0.5" y="0.5"></rect>
      <path  d="M0.5 10L5 6.5L7.5 9L13 4L16.5 8" stroke="black"></path>
      <circle  cx="4" cy="3" fill="#1E1F22" r="1"></circle>
    </svg>
  ),
  StaticInteriorImage: (
    <svg fill="none" height="38" viewBox="0 0 38 38" width="38" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#EEEEEE" height="38" rx="30" width="30"></rect>
      <path d="M19 21.5C17.4039 21.5 15.9837 21.1755 14.981 20.6741C13.9483 20.1578 13.5 19.537 13.5 19C13.5 18.463 13.9483 17.8422 14.981 17.3259C15.9837 16.8245 17.4039 16.5 19 16.5C20.5961 16.5 22.0163 16.8245 23.019 17.3259C24.0517 17.8422 24.5 18.463 24.5 19C24.5 19.537 24.0517 20.1578 23.019 20.6741C22.0163 21.1755 20.5961 21.5 19 21.5Z" stroke="#1E1F22"></path>
      <path d="M21.5 19C21.5 20.5961 21.1755 22.0163 20.6741 23.019C20.1578 24.0517 19.537 24.5 19 24.5C18.463 24.5 17.8422 24.0517 17.3259 23.019C16.8245 22.0163 16.5 20.5961 16.5 19C16.5 17.4039 16.8245 15.9837 17.3259 14.981C17.8422 13.9483 18.463 13.5 19 13.5C19.537 13.5 20.1578 13.9483 20.6741 14.981C21.1755 15.9837 21.5 17.4039 21.5 19Z" stroke="#1E1F22"></path>
    </svg>
  ),
};
